import React, { FC } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import SetupTimeColumn from '@v2/components/FinishJobModal/components/SetupTimeColumn';
import TotalCycleTimeColumn from '@v2/components/FinishJobModal/components/TotalCycleTimeColumn';
import type { TimeRegistrationSectionProps } from '@v2/components/FinishJobModal/types';

const TimeRegistrationSection: FC<TimeRegistrationSectionProps> = ({
  setupTimeRows,
  cycleTimeRows,
  producedQuantity,
  onSetupTimeChange,
  onCycleTimeChange,
  provenanceText,
  isBatchDataLoading,
  scale = initialScale,
  font = initialFont,
  C,
}) => {
  return (
    <View style={{ paddingHorizontal: scale(24), paddingBottom: scale(16) }}>
      <Text style={[font['Headline'], { color: C('Label/Light/Primary'), marginBottom: scale(16) }]}>
        {i18n.t('Time Registration')}
      </Text>

      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: scale(12) }}>
        <SetupTimeColumn rows={setupTimeRows} onActualChange={onSetupTimeChange} provenanceText={provenanceText} isBatchDataLoading={isBatchDataLoading} backgroundColor={C('Status/Light/Setup background')} scale={scale} font={font} C={C} />
        <TotalCycleTimeColumn rows={cycleTimeRows} producedQuantity={producedQuantity} onActualChange={onCycleTimeChange} provenanceText={provenanceText} isBatchDataLoading={isBatchDataLoading} backgroundColor={C('Status/Light/Productive background')} scale={scale} font={font} C={C} />
      </View>

    </View>
  );
};

export default TimeRegistrationSection;
